/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
import type { TranscriptSearchResult } from './TranscriptSearchResult.js';
import {
    TranscriptSearchResultFromJSON,
    TranscriptSearchResultFromJSONTyped,
    TranscriptSearchResultToJSON,
} from './TranscriptSearchResult.js';

/**
 * 
 * @export
 * @interface SearchScorecardSentenceResponse
 */
export interface SearchScorecardSentenceResponse {
    /**
     * 
     * @type {Array<TranscriptSearchResult>}
     * @memberof SearchScorecardSentenceResponse
     */
    data?: Array<TranscriptSearchResult>;
    /**
     * 
     * @type {number}
     * @memberof SearchScorecardSentenceResponse
     */
    totalRecords?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchScorecardSentenceResponse
     */
    page?: number;
    /**
     * 
     * @type {number}
     * @memberof SearchScorecardSentenceResponse
     */
    pages?: number;
    /**
     * 
     * @type {Array<Error>}
     * @memberof SearchScorecardSentenceResponse
     */
    errors?: Array<Error>;
}

/**
 * Check if a given object implements the SearchScorecardSentenceResponse interface.
 */
export function instanceOfSearchScorecardSentenceResponse(value: object): boolean {
    return true;
}

export function SearchScorecardSentenceResponseFromJSON(json: any): SearchScorecardSentenceResponse {
    return SearchScorecardSentenceResponseFromJSONTyped(json, false);
}

export function SearchScorecardSentenceResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): SearchScorecardSentenceResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'data': json['data'] == null ? undefined : ((json['data'] as Array<any>).map(TranscriptSearchResultFromJSON)),
        'totalRecords': json['totalRecords'] == null ? undefined : json['totalRecords'],
        'page': json['page'] == null ? undefined : json['page'],
        'pages': json['pages'] == null ? undefined : json['pages'],
        'errors': json['errors'] == null ? undefined : json['errors'],
    };
}

export function SearchScorecardSentenceResponseToJSON(value?: SearchScorecardSentenceResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'data': value['data'] == null ? undefined : ((value['data'] as Array<any>).map(TranscriptSearchResultToJSON)),
        'totalRecords': value['totalRecords'],
        'page': value['page'],
        'pages': value['pages'],
        'errors': value['errors'],
    };
}

